import React from 'react';
import { useSelector } from 'react-redux';

export const DataNotFound = () => {
  const isActive = useSelector((state) => state.toggle.isActive);

  return (
    <div className="text-center flex justify-center my-6 mx-auto">
      <img src={ `/assets/images/${isActive ? 'dataNotfound_ar.png' : 'dataNotfound.png'}`} alt="dataNotfound" />
    </div>
  );
};
